export enum CountdownInterval {
	DAYS = 'Days',
	TIME = 'Time'
}
